module.exports = __webpack_public_path__ + "img/responsive crc-04.6b7d34ba.jpg";